import React from 'react'

const SlickprevCircle = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 82 82"
            height={80}
            width={80}
            {...props}
        >
            <path
                stroke="#080807"
                strokeMiterlimit="10"
                d="M61.71 41.423H21.133m0 0c7.47 0 13.526-6.055 13.526-13.526M21.133 41.423c7.47 0 13.526 6.054 13.526 13.526"
            />
            <circle cx="41" cy="41" r="40.5" stroke="#080807" />
        </svg>
    )
}

export default SlickprevCircle
